import React from 'react';
import { Sparkles } from 'lucide-react';
import { themes } from './themes';

const CoverSlide = ({ title, subtitle, theme, sizeClass }) => {
  const t = themes[theme] || themes['modern-minimal'];
  return (
    <div
      className={`w-full ${sizeClass || 'aspect-square'} overflow-hidden relative flex flex-col items-center justify-center text-center p-10`}
      style={{ backgroundColor: t.accent }}
    >
      <div className="absolute top-8 right-8 w-24 h-24 rounded-full opacity-10" style={{ backgroundColor: t.bg }} />
      <div className="absolute bottom-12 left-12 w-40 h-40 rounded-full opacity-5" style={{ backgroundColor: t.bg }} />
      <div className="mb-6 opacity-80" style={{ color: t.bg }}>
        <Sparkles className="w-10 h-10" strokeWidth={1} />
      </div>
      <h1 className="leading-tight mb-3 relative z-10" style={{
        fontFamily: t.font, fontWeight: 700,
        fontSize: 'clamp(1.75rem, 5vw, 2.5rem)',
        color: t.bg, lineHeight: 1.15
      }}>
        {title}
      </h1>
      {subtitle && (
        <p className="relative z-10" style={{
          fontFamily: t.bodyFont,
          fontSize: 'clamp(0.85rem, 2vw, 1.1rem)',
          color: t.bg + 'BB'
        }}>
          {subtitle}
        </p>
      )}
      <div className="absolute bottom-6" style={{ color: t.bg + '60', fontFamily: t.bodyFont, fontSize: '0.7rem', letterSpacing: '0.15em' }}>
        CREATED WITH LUMERA STUDIO
      </div>
    </div>
  );
};

export default CoverSlide;
